import { authorisedContact } from "../../config/contact";
import React from "react";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaClock,
  FaCar,
  FaBus,
  FaGlobe,
  FaDirections,
} from "react-icons/fa";

export default function LiveLocation() {
  const infoCard = {
    background: "#fff",
    borderRadius: "18px",
    padding: "25px",
    boxShadow: "0 8px 20px rgba(0,0,0,.08)",
    marginBottom: "20px",
  };

  return (
    <section
      style={{
        padding: "80px 8%",
        background: "#f8fafc",
      }}
    >
      <div
        style={{
          textAlign: "center",
          marginBottom: "60px",
        }}
      >
        <FaMapMarkerAlt size={60} color="#0284c7" />

        <h1
          style={{
            fontSize: "42px",
            color: "#0f172a",
            marginTop: "20px",
          }}
        >
          Visit Our Campus
        </h1>

        <p
          style={{
            maxWidth: "700px",
            margin: "20px auto",
            color: "#64748b",
            lineHeight: "30px",
          }}
        >
          Find our institute location, contact details, office timings,
          transportation information and navigate directly using Google Maps.
        </p>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1.3fr 1fr",
          gap: "40px",
        }}
      >
        {/* Google Map */}

        <div
          style={{
            background: "#fff",
            borderRadius: "20px",
            overflow: "hidden",
            boxShadow: "0 10px 25px rgba(0,0,0,.08)",
          }}
        >
          <iframe
            title="Google Map"
            src="https://www.google.com/maps?q=Kolkata&output=embed"
            width="100%"
            height="650"
            style={{
              border: 0,
            }}
            loading="lazy"
          ></iframe>
        </div>

        {/* Right Side */}

        <div>

          <div style={infoCard}>
            <h2
              style={{
                color: "#0284c7",
                marginBottom: "20px",
              }}
            >
              Campus Address
            </h2>

            <p>
              <FaMapMarkerAlt color="#0284c7" /> XYZ Institute of Technology
            </p>

            <p>
              Sector V, Salt Lake,
              Kolkata, West Bengal - 700091
            </p>
          </div>

          <div style={infoCard}>
            <h2
              style={{
                color: "#16a34a",
                marginBottom: "20px",
              }}
            >
              Contact Details
            </h2>

            <p>
              <FaPhoneAlt color="#16a34a" /> <a href={authorisedContact.telephone}>{authorisedContact.phone}</a>
            </p>

            <p>
              <FaEnvelope color="#16a34a" /> info@college.edu
            </p>

            <p>
              <FaGlobe color="#16a34a" /> www.college.edu
            </p>
          </div>

          <div style={infoCard}>
            <h2
              style={{
                color: "#0284c7",
                marginBottom: "20px",
              }}
            >
              Office Hours
            </h2>

            <p>
              <FaClock color="#0284c7" /> Monday - Friday
            </p>

            <p>09:00 AM - 06:00 PM</p>

            <p>Saturday : 09:00 AM - 02:00 PM</p>

            <p>Sunday : Closed</p>
          </div>

          <div style={infoCard}>
            <h2
              style={{
                color: "#16a34a",
                marginBottom: "20px",
              }}
            >
              Transport
            </h2>

            <p>
              <FaBus color="#16a34a" /> Bus Stop : 300m
            </p>

            <p>
              <FaCar color="#16a34a" /> Parking Available
            </p>

            <p>Nearest Metro : Sector V Metro Station</p>
          </div>

          <div
            style={{
              display: "flex",
              gap: "15px",
              flexWrap: "wrap",
              marginTop: "20px",
            }}
          >
            <a
              href="https://maps.google.com"
              target="_blank"
              rel="noreferrer"
              style={{
                flex: 1,
                background: "#0284c7",
                color: "#fff",
                textDecoration: "none",
                padding: "15px",
                borderRadius: "10px",
                textAlign: "center",
                fontWeight: "bold",
              }}
            >
              <FaDirections /> Get Directions
            </a>

            <a
              href={authorisedContact.telephone}
              style={{
                flex: 1,
                background: "#16a34a",
                color: "#fff",
                textDecoration: "none",
                padding: "15px",
                borderRadius: "10px",
                textAlign: "center",
                fontWeight: "bold",
              }}
            >
              <FaPhoneAlt /> Call Now
            </a>
          </div>

        </div>
      </div>

      {/* Bottom Section */}

      <div
        style={{
          marginTop: "70px",
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit,minmax(250px,1fr))",
          gap: "25px",
        }}
      >
        {[
          {
            title: "Students",
            value: "5000+",
          },
          {
            title: "Faculty",
            value: "200+",
          },
          {
            title: "Campus Area",
            value: "25 Acres",
          },
          {
            title: "Placement Rate",
            value: "98%",
          },
        ].map((item, index) => (
          <div
            key={index}
            style={{
              background: "#fff",
              padding: "30px",
              borderRadius: "18px",
              textAlign: "center",
              boxShadow: "0 8px 20px rgba(0,0,0,.08)",
            }}
          >
            <h3>{item.title}</h3>

            <h1
              style={{
                color: "#0284c7",
                marginTop: "15px",
              }}
            >
              {item.value}
            </h1>
          </div>
        ))}
      </div>
    </section>
  );
}